import styled from "styled-components";
import {
  Form as AntForm,
  Input as AntInput,
	Select as AntSelect,
	Button as AntButton,
} from 'antd'

export const RootContainer = styled.div`
	min-height: calc(100vh - 110px);
	display: flex;
	justify-content: flex-start;
	align-items: left;
	flex-direction: column;
	padding: 20px 16px;

	position: relative;

	.ant-form-item-label {
		text-align: center;
		font-size: 16px;
	}

`;

export const Form = styled(AntForm)`
	width: 100%;
	height: 100%;
	position: relative !important;
	margin-bottom: 100px;
	min-height: calc(100vh - 110px);

	.ant-form-item {
		margin: 0 0 24px 0px;
	}

	.ant-form-item-label > label.ant-form-item-required::before {
		content: none;
	}

	.ant-form-item-label label {
		color: #9F9FA2;
		font-size: 14px;
		font-weight: 200;
		line-height: 17.5px;
		display: flex;
		margin-left: 18px;
	}

	.ant-form-item-explain {
		text-align: left; /* align warning text to the left */
		margin-left: 24px;
	}
`;

export const Select = styled(AntSelect)`
	input{
		font-size: 16px !important;
	}
	.ant-select-selector{
		background-color: #050508 !important;
		border: ${props => props.isFilled === "true" ? "1px solid #424242" : "1px solid red"} !important;
		height: 40px !important;
		padding: 0 16px !important;
		box-sizing: border-box;

		display: flex;
		flex-direction: row;
		align-items: center;

		color: #F9F9F9 !important;
		font-size: 16px !important;
	}

	.ant-select-selector-search-input{
		height: 40px !important;
		color: #F9F9F9 !important;
		font-size: 16px !important;
	}

	.ant-select-selection-placeholder {
		color: #F9F9F9;
		font-size: 16px !important;
	}


`

export const Input = styled(AntInput)`
	border-radius: 8px;
	border: 1.5px solid #212224;
	height: 52px;
	background-color: #050508;

	text-align: left !important;
	color: white;
	font-size: 16px;

	&:focus{
		background-color: #050508 !important;
		color: white;
	}

	&::placeholder {
		color: #686b6e;
		font-weight: 400;
		font-size: 16px;
		line-height: 20px;
		text-align: left;
	}

	&&& {
		padding-left: 16px;
	}
`;

export const TextArea = styled(AntInput.TextArea)`
	border-radius: 8px;
	border: 1.5px solid #212224;
	height: 52px;
	background-color: #050508 !important;
	padding: 15px;

	text-align: left !important;
	color: white;
	font-size: 16px;

	&:focus{
		background-color: #050508 !important;
		color: white;
	}

	&::placeholder {
		color: #686b6e;
		font-weight: 400;
		font-size: 16px;
		line-height: 20px;
		text-align: left;
	}

`

export const ButtonContainer = styled.div`
	width: calc(100%);
	margin-top: 30px;

	display: flex;
	flex-direction: row;
	column-gap: 16px;
	justify-content: space-between;
	align-items: center;
`

export const Button = styled(AntButton)`
  width: 100% !important;
  height: 56px !important;
  background: ${(props) =>
    props.type === "cancel"
      ? "#F9F9F9"
      : "linear-gradient(90deg, #FFB829 0%, #914706 100%)"} !important;
  border-radius: 12px !important;
	border: none !important;

  font-size: 16px;
  color: ${props => props.type === "cancel" ? "#0E1017" : "#FFF"} !important;
  font-weight: 600px;

	:disabled{
		cursor: not-allowed;
	}	

  :hover {
    background: ${(props) =>
    props.type === "cancel"
      ? "#F9F9F9"
      : "linear-gradient(90deg, #FFB829 0%, #914706 100%)"} !important;
    color: ${props => props.type === "cancel" ? "#0E1017" : "#FFF"} !important;
  }

  @media screen and (max-width: 420px){
    height: 52px !important;
    font-size: 15px;
  }

  @media screen and (max-width: 350px){
    height: 48px !important;
    font-size: 14px;
  }
`

export const PendingContainer = styled.div`
	height: calc(100vh - 110px);
	padding: 30px 0 0;
	box-sizing: border-box;

	display: flex;
	flex-direction: column;
	align-items: center;

	position: relative;
`

export const PendingTitle = styled.p`
	color: #FFB829;
	font-size: 18px;
	font-weight: bold;
	line-height: normal;

	margin: 20px 0 16px;
`

export const PendingDesc = styled.p`
	color: #EFEFEF;
	font-size: 16;
	font-weight: normal;
	line-height: normal;

	text-align: center;
`

export const BottomText = styled.p`
	color: rgb(255, 184, 41);
	font-size: ${props => props.isBurmese === "true" ? "14px" : "16px"};
	font-weight: normal;
	line-height: normal;

	position: absolute;
	bottom: 0;

	@media screen and (max-width: 350px){
		font-size: ${props => props.isBurmese === "true" ? "12px" : "14px"};
	}
	
`

export const Loader = styled.div`
	width: 100%;
	height: calc(100vh);
	display: flex;
	align-items: center;
	justify-content: center;
`;